// removed by extract-text-webpack-plugin
module.exports = {"root":"_3kFjF","heading":"_1c4fX","plans":"_2evjG"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Premium/components/SubscriptionSection/SubscriptionSection.scss
// module id = 1331
// module chunks = 3